import { useDispatch, useSelector } from 'react-redux';
import './ItemFeed.css'
import React, { useEffect, useState, useRef } from 'react'
import Reference from '../CreateDatum/AddReferenceModal/Reference/Reference';
import { getItemFeed } from '../../../actions/ItemAction';
import { MdFilterAltOff } from 'react-icons/md';
import { searchUsers } from '../../../api/UserRequest';
import { BiFilterAlt, BiTrash } from 'react-icons/bi';
import InfiniteScrollLoader from './InfiniteScrollLoader';
import { saveFilters, loadFilters, clearSavedFilters } from '../../../utils/filterPersistence';
import { TbFaceIdError } from 'react-icons/tb';

const ItemFeed = ({ sortOrder, user: propUser }) => {

    const dispatch = useDispatch();
    const { user: reduxUser } = useSelector((state) => state.authReducer.authData);
    const { loading: authDataLoading } = useSelector((state) => state.authReducer);
    const { itemFeed, loading: itemFeedLoading, hasMore, totalItems } = useSelector((state) => state.itemFeedReducer);
    const [page, setPage] = useState(0);
    const user = propUser || reduxUser;
    const [userSearchResults, setUserSearchResults] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [userSearchInput, setUserSearchInput] = useState('');
    
    const FILTER_KEY = 'itemFeed_filters'
    const filtersObj = {
        sort: sortOrder,
        authoredOnly: false,
        username: null,
        followed: false,

    }
    const [filters, setFilters] = useState(() => loadFilters(FILTER_KEY, filtersObj, user._id));

    useEffect(() => {
        saveFilters(FILTER_KEY, filters, user._id);
      }, [filters]);


    useEffect(() => {
        if (!authDataLoading) {
            const savedFilters = loadFilters(FILTER_KEY, filtersObj, user._id)
            dispatch(getItemFeed(user._id, JSON.stringify(savedFilters), 0));
        }

    }, [authDataLoading])

    useEffect(() => {
        const restoreFilters = async () => {
            const saved = loadFilters(FILTER_KEY, filtersObj, user._id);
            if (saved.username && saved.authorUserId) {
                const res = await searchUsers(saved.username, 1);
                const match = res.data.find(u => u._id === saved.authorUserId || u.username === saved.username);
                if (match) setSelectedUser(match);
            }
        };
        restoreFilters();
    }, []);

    const hasMoreRef = useRef(hasMore);
    const isFetchingRef = useRef(false);
    const loadingRef = useRef(itemFeedLoading);
    const pageRef = useRef(page);
    const filtersRef = useRef(filters)

    useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);
    useEffect(() => { loadingRef.current = itemFeedLoading; }, [itemFeedLoading]);
    useEffect(() => { pageRef.current = page; }, [page]);
    useEffect(() => {filtersRef.current = filters; }, [filters]);

    useEffect(() => {
        const appContainer = document.querySelector('.App');
        
        const handleScroll = () => {
            const nearBottom =
                appContainer.scrollHeight - appContainer.scrollTop - appContainer.clientHeight < 200;
                        
            if (nearBottom && hasMoreRef.current && !isFetchingRef.current) {
                isFetchingRef.current = true
                const nextPage = pageRef.current + 1;
                setPage(nextPage);
                dispatch(getItemFeed(user._id, JSON.stringify(filtersRef.current), nextPage)).finally(() => {
                    isFetchingRef.current = false;
                });
            }
        };
    
        appContainer.addEventListener('scroll', handleScroll);
        return () => appContainer.removeEventListener('scroll', handleScroll);
    }, []);

    


    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value })
    }

    const handleChecked = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.checked })
    }

    const handleSubmitFilters = (e) => {
        e.preventDefault();
        setPage(0);
        dispatch(getItemFeed(user._id, JSON.stringify(filters), 0))
    }
    const sortedItems = () => {
        if (!Array.isArray(itemFeed)) return [];  // Check if itemFeed is empty or undefined
    
        return [...itemFeed].sort((a, b) => {
            // Ensure a and b are valid objects and have 'links' property (even if it's an empty array)
            const aLinksLength = a && Array.isArray(a.links) ? a.links.length : 0;
            const bLinksLength = b && Array.isArray(b.links) ? b.links.length : 0;
    
            // Sort by number of links if the sortOrder is 'mostReferenced'
            if (sortOrder === 'mostReferenced') {
                return bLinksLength - aLinksLength;  // Sort by length of links array, descending
            } 
            // Sort by 'createdAt' if the sortOrder is 'recentlyAuthored'
            else if (sortOrder === 'recentlyAuthored') {
                // Ensure createdAt is a valid date
                const aDate = a && a.createdAt ? new Date(a.createdAt) : new Date(0);  // Fallback to epoch if no createdAt
                const bDate = b && b.createdAt ? new Date(b.createdAt) : new Date(0);  // Fallback to epoch if no createdAt
                return bDate - aDate;  // Sort by createdAt, descending
            }
            
            return 0;  // Default: no sorting
        });
    };
    const handleUsernameSearch = async (e) => {
        const value = e.target.value;
        setUserSearchInput(value);
        if (value.length > 2) {
            const res = await searchUsers(value, 1);
            setUserSearchResults(res.data);
        } else {
            setUserSearchResults([]);
        }
    };
    
    const selectUser = (user) => {
        setSelectedUser(user);
        setUserSearchResults([]);
        setUserSearchInput('');
        setFilters({ ...filters, authorUserId: user._id, username: user.username });
    };
    
    const removeSelectedUser = () => {
        setSelectedUser(null);
        setUserSearchInput('');
        setFilters({ ...filters, authorUserId: null, username: null });
    };
    const clearFilters = () => {
        clearSavedFilters(FILTER_KEY, user._id)
        setFilters(filtersObj);
        setPage(0)
        setSelectedUser(null);
        setUserSearchInput('');
        setUserSearchResults([]);
        document.querySelectorAll('#itemFeed_filter_bar input[type="text"]').forEach(input => {
            input.value = '';
        });
        document.querySelectorAll('#itemFeed_filter_bar input[type="checkbox"]').forEach(input => {
            input.checked = false;
        });
        dispatch(getItemFeed(user._id, JSON.stringify(filtersObj), 0));
    };

    function NoItems() {
        var noItemsText = "";
        switch(user.userType) {
            case 0:
                if (user.follow.length === 0) {
                   noItemsText = "You aren't following any Groups yet!  Click on Find Groups above, follow one or more whose Values align with yours, and you'll begin to see the Items that they think are most important for you to see.";    
                } else {
                    noItemsText = (
                        <>
                            Check your Filter and Sort options in the <span className="General-inline-icon"><BiFilterAlt /></span> menu above and try removing some filters.
                        </>
                    );
                }
                break;
            case 1:
                noItemsText = "Once you create your first Item, it will appear here when viewing 'My Authored Data' from the Filter and Sort menu.  Once you reference an Item in a Datum taht you create, it will appear here when viewing 'My Referenced Items' from the Filter and Sort menu.";
                break;
            case 2:
                noItemsText = "You have not stamped any Data yet.  Once you begin stamping Data, the Items that they reference will appear here."
                break;
        }
        return (
            <div className='General-nr-container'>
                <span className='General-nr-top'>You don't have any Items to view.</span>
                <TbFaceIdError size='30'/>
                <div className='General-nr-hint'>{noItemsText}</div>
            
            </div>
        )
    }


    return (
        <>
            
            <div className="General-filter-bar General-hidden" id="itemFeed_filter_bar">
                
                <form action="" className='FlexColumn General-filter-form' onSubmit={handleSubmitFilters}>
                <span className='FlexRow General-filter-form'>
                    <span className='General-filter-key'>Username:</span>
                    <div className='user-search-container'>
                        {selectedUser ? (
                            // Selected user display
                            <div className='user-search-selected FlexRow'>
                                <img 
                                    src={process.env.REACT_APP_PUBLIC_FOLDER + selectedUser.userImage} 
                                    className='user-search-img'
                                />
                                <span>{selectedUser.displayname}</span>
                                <span className='user-search-at'>@{selectedUser.username}</span>
                                <BiTrash
                                    className='user-search-remove' 
                                    onClick={removeSelectedUser} 
                                />
                            </div>
                        ) : (
                            // Search input
                            <input
                                type="text"
                                placeholder="Search by username..."
                                className='General-input'
                                value={userSearchInput}
                                onChange={handleUsernameSearch}
                            />
                        )}
                        {/* Dropdown results */}
                        {userSearchResults.length > 0 && (
                            <div className='user-search-dropdown'>
                                {userSearchResults.map((u) => (
                                    <div 
                                        key={u._id} 
                                        className='user-search-result FlexRow'
                                        onClick={() => selectUser(u)}
                                    >
                                        <img 
                                            src={process.env.REACT_APP_PUBLIC_FOLDER + u.userImage} 
                                            className='user-search-img'
                                        />
                                        <div className='FlexColumn'>
                                            <span>{u.displayname}</span>
                                            <span className='user-search-at'>@{u.username}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </span>
                <span className='FlexRow General-filter-form'>
                    <span className='General-filter-key'>Keyword:</span>
                    <div style={{ position: 'relative', width: '77%' }}>
                        <input
                            type="text"
                            placeholder="Filter by keyword..."
                            name="keyword"
                            className='General-input'
                            value={filters.keyword || ''}
                            onChange={handleChange}
                            style={{ paddingRight: '24px', width: '100%' }}
                        />
                        {filters.keyword && (
                            <BiTrash
                                onClick={() => setFilters({ ...filters, keyword: null })}
                                style={{ 
                                    position: 'absolute', 
                                    top: '50%',
                                    marginLeft: 'auto', 
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: '#6b7280'
                                }}
                            />
                        )}
                    </div>
                </span>
                    {user.userType === 1 && (
                        <div className='FlexRow General-filter-form' style={{ alignItems: 'center', gap: '10px' }}>
                            <span className='General-filter-key' style={{ color: !filters.authoredOnly ? '#3b82f6' : '#6b7280' }}>
                                My Referenced Items
                            </span>
                            <div 
                                className='toggle-switch'
                                onClick={() => {
                                    const updated = { ...filters, authoredOnly: !filters.authoredOnly };
                                    setFilters(updated);
                                    dispatch(getItemFeed(user._id, JSON.stringify(updated)));
                                }}
                            >
                                <div className={`toggle-knob ${filters.authoredOnly ? 'toggle-knob-on' : ''}`}></div>
                            </div>
                            <span className='General-filter-key' style={{ color: filters.authoredOnly ? '#3b82f6' : '#6b7280' }}>
                                My Authored Items
                            </span>
                        </div>
                    )}
                    {user.userType === 0 && (
                        <div className='FlexColumn General-filter-form'>
                            <span className='FlexRow General-filter-form'>
                                <span className='General-filter-key'>Include Followed:</span>
                                <input id="followed" name="followed" type="checkbox" onClick={handleChecked} checked={filters.followed || false} />
                            </span>
                        </div>
                    )}

                    <div className='FlexRow General-filter-form items-center flex justify-center'>
                        <button className='button signupButton' type='submit'>
                          Apply Filters
                        </button>
                        <button 
                          className='button signupButton' 
                          type='button' 
                          onClick={clearFilters}
                          title='Clear all filters'
                        >
                          <MdFilterAltOff />
                        </button>
                    </div>
                </form>
            </div>
            <div className='feed-result-count'>
                {itemFeedLoading ?
                "Loading" :
                `Search returned ${totalItems} ${totalItems === 1 ? 'Item' : 'Items'}`}
            </div>
            <div className="ItemFeed">
                {sortedItems().length > 0 ? (
                    sortedItems().map((item, _id) => (
                        <Reference reference={item} key={_id} location="itemList" />
                    ))
                ) : (
                    <NoItems/>
                )}
            </div>
            {sortedItems().length > 0 && (
                <InfiniteScrollLoader hasMore={hasMore} />
            )}
        </>

    )
}

export default ItemFeed